let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d8WL7")).then(() => parcelRequire('bIxfG'));